// @flow
import LayoutElement from './LayoutElement';

export default class Layout {
  columns: number = 1;

  rows: number = 1;

  selectedViewIndex: number = 0;

  viewsGroup: Array<number> = [0];

  showExplorer: Boolean = true;

  showHistory: Boolean = false;

  currentTool: String = 'Wwwc';

  isRefLines: Boolean = false;

  isContinuousScroll: Boolean = false;

  elements: Array<LayoutElement> = [];

  is3DModeEnabled: Boolean = false;

  isMPRModeEnabled: Boolean = false;
  
  isSelectedPreset: Boolean = false;
}
